import { WrapWithSectionItem } from "../sections";
import TextValue from "@/components/tableElements/TextValue.vue";
import HighlightTextValue from "@/components/tableElements/HighlightTextValue.vue";
export default {
  name: "TargetingTypeFilterItem",
  emits: ["select", "selectOnly", "deselect"],
  props: {
    name: String,
    itemKey: String,
    selected: Boolean,
    // Search term to highlight within the label.
    query: {
      type: String,
      default: ""
    }
  },
  components: {
    WrapWithSectionItem,
    TextValue,
    HighlightTextValue
  }
};